import { render, staticRenderFns } from "./ModuleMapForm.vue?vue&type=template&id=471d2295&scoped=true"
import script from "./ModuleMapForm.vue?vue&type=script&lang=js"
export * from "./ModuleMapForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleMapForm.vue?vue&type=style&index=0&id=471d2295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d2295",
  null
  
)

export default component.exports